"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const DropdownItemAriaContext = createContext({});
const DropdownItemAriaContextProvider = DropdownItemAriaContext.Provider;
const useDropdownItemAriaContext = () => {
  return useContext(DropdownItemAriaContext);
};

export { DropdownItemAriaContextProvider, useDropdownItemAriaContext };
